export default "__VITE_ASSET__DVkyWF50__"